import React, { useContext, useEffect, useState } from 'react'
import { UserContext } from '../contexts/user';
import BannerReportTIM from './BannerReportTIM'
import { Alert, Box, Button, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from '@mui/material'
import SaveIcon from '@mui/icons-material/Save';
import { createAnswer, getExtraAnswer, updateAnswer } from '../axios/axiosFunctions';

const BlockEndTIM = ({slug,onExtraQChange}) => {


    const {currentUser} = useContext(UserContext);
    const [answerText, setAnswerText] = useState("");
    const [showError, setShowError] = useState(false);
    const [defaultAnswer, setDefaultAnswer] = useState();
    const [error, setError] = useState("");
    const [alertSeverity, setAlertSeverity] = useState("error"); 

    useEffect(() => {
        const callExtraAnswer = async()=>{
            const res = await getExtraAnswer(slug,currentUser._id)
            if(res && res.answer){
                setDefaultAnswer(res.answer);
                setAnswerText(res.answer.answer);
                onExtraQChange?.(res.answer.answer);
            }
        }
        callExtraAnswer();
    }, []);

    const handleChange = (e)=>{
        const {value} = e.target;
        setAnswerText(value);
    }

    const submitAnswer = async()=>{
        let res;

        if(defaultAnswer){
            const data = {
                answer: answerText     
            }
            res = await updateAnswer(defaultAnswer._id,data);
        }else{
            const data = {
                user: currentUser._id,
                answer: answerText,
                slug
            }
            res = await createAnswer(data);
        }
        
        if(!res){
            setError("Error while saving please try later");
            setShowError(true);
            setTimeout(() => {
              setShowError(false);
            }, 4000);
            return;
        }
        /* onBlockNoteChange?.(blockId, answerText); */
        setDefaultAnswer(res.answer);
        onExtraQChange?.(answerText);
        setError("Saved correctly");
        setAlertSeverity("success");
        setShowError(true);
        setTimeout(() => {
            setShowError(false);
        }, 2000);

    }

    return (
    <>
    <BannerReportTIM text={"Team Development Planning"}/>
    <Box display="flex" flexDirection="column" sx={{padding:"0px 48px"}}>
        <Grid container spacing={2} sx={{margin:"24px 0px 40px 0px"}}>
            <Grid size={12}>
                <Typography variant="body1" color="secondary" fontWeight={400} sx={{lineHeight:"1.7",fontSize:"1.05rem"}}>Every team is constantly changing and growing. Expert Teams make continuous improvement an intentional part of how they operate. After reviewing your team results, consider the following table as a way to prioritize your team's focus areas.</Typography>
                <Box display={"flex"} justifyContent={"center"}>
                    <TableContainer sx={{maxWidth:"550px",margin:"32px 0px",borderRadius:"8px",overflow:"hidden",boxShadow:"0 1px 4px rgba(15,83,133,0.08)"}}>
                        <Table sx={{borderCollapse:'separate',borderSpacing:0,'& .MuiTableCell-root':{border:'none',padding:'12px 20px',fontSize:'0.95rem'}}}>
                            <TableHead>
                                <TableRow sx={{backgroundColor:"#0F5385"}}>
                                    <TableCell sx={{fontWeight:"600",color:"white"}}>Score (% of positive responses)</TableCell>
                                    <TableCell sx={{fontWeight:"600",color:"white"}}>Rating</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow sx={{backgroundColor:"#f0f7f0"}}>
                                    <TableCell>90% or higher</TableCell>
                                    <TableCell sx={{fontWeight:600,color:"#69AF45"}}>STRENGTH</TableCell>
                                </TableRow>
                                <TableRow sx={{backgroundColor:"#f5f9fc"}}>
                                    <TableCell>60%–89%</TableCell>
                                    <TableCell sx={{fontWeight:600,color:"#2B8DCC"}}>DEVELOPING</TableCell>
                                </TableRow>
                                <TableRow sx={{backgroundColor:"#fef8f0"}}>
                                    <TableCell>Less than 60%</TableCell>
                                    <TableCell sx={{fontWeight:600,color:"#e67e22"}}>OPPORTUNITY</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            </Grid>
            <Grid size={12}>
                <Typography variant="body1" color="secondary" fontWeight={600} sx={{fontSize:"1.05rem",marginBottom:"8px"}}>Identify your team's top 3 priorities</Typography>
                <TextField value={answerText} onChange={handleChange} fullWidth multiline rows={5}/>
            </Grid>
            {
                showError &&
                <Grid size={12}>
                    <Alert sx={{marginTop:"20px"}} severity={alertSeverity}>
                        {error}
                    </Alert>
                </Grid>
            }
            <Grid display={"flex"} alignItems={"center"} gap={2}>
                <Typography variant="body2" color="secondary" sx={{fontStyle:"italic",opacity:0.8}}>Make sure to SAVE on each section.</Typography>
                <Button onClick={submitAnswer} variant="contained" sx={{marginTop:"16px",marginBottom:"48px"}} startIcon={<SaveIcon/>}>Save</Button>
            </Grid>
            <Grid display={"flex"} justifyContent={"flex-end"} size={12}>
                <Typography variant="body1" color="secondary" fontWeight={400} sx={{lineHeight:"1.7",fontSize:"1rem"}}>If your team is already enrolled in the Know2Grow Teams in Motion program, use these suggestions to focus your efforts. To enroll in the Teams in Motion<sup style={{fontSize:"0.65em",verticalAlign:"super"}}>®</sup> program, visit Know2Grow.com</Typography>
            </Grid>
        </Grid>
    </Box>
    </>
    )
}

export default BlockEndTIM